var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.logic && _vm.logic.created)?_c('v-container',{staticStyle:{"max-width":"900px"},attrs:{"fluid":""}},[_c('Produkte',{attrs:{"logic":_vm.logic}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }